module.exports = __webpack_public_path__ + "media/images/cbs/map-1320f99b5168ac8237c92e1cbd36bd90.svg";